$(document).on 'turbolinks:load', ->
  options =
    valueField: 'email',
    # server hledá i podle jména, příjmení a firmy (každé slovo zvlášť); selectize si drží výsledky
    # i z předchozích dotazů, proto je stejně profiltrujeme — každé slovo musí být v některém poli
    searchField: ['email', 'first_name', 'surname', 'company'],
    score: (search) ->
      words = String(search?.query ? search).toLowerCase().split(/\s+/).filter((w) -> w.length >= 2)
      (item) ->
        text = [item.email, item.first_name, item.surname, item.company].join(' ').toLowerCase()
        if words.length && words.every((w) -> text.indexOf(w) >= 0) then 1 else 0
    labelField: 'email',
    loadThrottle: 400,
    delimiter: null,
#    options: [],
    create: true,
    createOnBlur: true,
    maxItems: 1,

    # vybraný e-mail jde po kliknutí přepsat — vrátí se do textu (označený, psaní ho nahradí);
    # když se nic nevybere ani nenapíše, vrátí se původní (tiše, aby nepřepsal ručně upravenou adresu)
    onFocus: ->
      @previousEmail = @getValue()
      return unless @previousEmail
      @clear(true)
      @setTextboxValue(@previousEmail)
      @$control_input[0].select()
    onBlur: ->
      @setValue(@previousEmail, true) if @previousEmail && !@getValue()
      @previousEmail = null

    load: (query, callback)->
      if query.length < 2
        return callback()
      sourceId = $('#order_source_id').val() || ''
      $.ajax {
        url: '/orders/by_email.json?email=' + encodeURIComponent(query) + '&source_id=' + encodeURIComponent(sourceId),
        type: 'GET',
        error: ->
        success: (res)->
          callback(res)
      }
    render:
      option_create: (data, escape) ->
        "<div class='create'>#{escape $('#new_order #order_email').data('add')} <strong>#{escape data.input}</strong>&hellip;</div>"
      option: (item, escape) ->
        return "<div>#{escape item.email}</div>" unless item.last_order
        name = [item.first_name, item.surname].filter((x) -> x).join(' ')
        title = [item.company, name].filter((x) -> x).join(' – ')
        address = [item.street, [item.zip, item.town].filter((x) -> x).join(' '), item.country].filter((x) -> x).join(', ')
        "<div class='py-1'><strong>#{escape title}</strong> <span class='text-muted'>#{escape item.email}</span>" +
          "#{if item.phone then ' · ' + escape(item.phone) else ''}<br />" +
          "<small>#{escape address}</small> <small class='text-muted float-right'>#{escape $('#new_order #order_email').data('last-order')} #{escape item.last_order}</small></div>"

    onChange: (value)->
      return if value == @previousEmail
      item = this.options[value]
      if(item && item['email'] && item['town'])
        fill = ['company', 'first_name', 'surname', 'street', 'town', 'zip', 'country', 'phone', 'del_company', 'del_name', 'del_surname', 'del_street', 'del_town', 'del_zip', 'del_country', 'del_phone', 'del_email', 'region', 'del_region', 'ic', 'dic']
        for k in fill
          $('#order_' + k).val(item[k] ? '');
        # země jsou bootstrap-select — bez refresh by se zobrazila stará volba
        $('#order_country, #order_del_country').selectpicker('refresh')

        if item.del_street and !$('#dodaci_cb').is(':checked')
          $('#dodaci_cb').click()
    onPaste: (e) ->
      console.log 'Pasted'
      self = this
      if self.isFull() or self.isInputHidden or self.isLocked
        e.preventDefault()
        console.log 'Full or locked'
      else
      # If a regex or string is included, this will split the pasted
      # input and create Items for each separate value
          setTimeout((->
            if self.settings.splitOn
              splitInput = $.trim(self.$control_input.val() or '').split(self.settings.splitOn)
              i = 0
              n = splitInput.length
              while i < n
                self.createItem splitInput[i]
                i++
            self.onKeyUp e
            return
          ), 0)





  $('#new_order #order_email').removeClass( "form-control" )
  $email = $('#new_order #order_email').selectize options
  # jiný zdroj = jiný klient → výsledky hledání z předchozího zdroje neplatí
  $('#new_order #order_source_id').on 'change', ->
    selectize = $email[0]?.selectize
    selectize?.clearOptions() unless selectize?.getValue()